export default __webpack_public_path__ + "static/media/srcdev_pj.85bf8f20.png";